import { environment } from "src/environments/environment";

export const SendGridService = {
	sendEmail: async (data: any) => await fetch(`${environment.externalAPIs.sendGrid.api}`, {body: JSON.stringify(data), headers: {"Content-Type": "application/json"}, method: "POST"})
}